
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarCube as ObiBuoyPilarCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-cube.js';
 
 
 

 
 export const ObiBuoyPilarCube = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-cube',
   elementClass: ObiBuoyPilarCubeElement,
   events: {
     
   }
  });
 
 